import module0 from '@ice/plugin-icestark/esm/runtime/framework';
                import module1 from '@ice/plugin-request/runtime';
                import module2 from '@ice/plugin-store/runtime';
                
export const statics = [
  module1,
];
export const commons = [
  module0,
  module2,
];
